const INITIAL_STATE = {
    doctors: [],
    count: 0,
    loading: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GET_DOCTORS": {
            return {
                ...state,
                doctors: action.doctors,
                count: action.count,
                loading: false
            }
        }
        default:
            return state
    }
}
